module.exports = __webpack_public_path__ + "static/media/remove_prodOLD.153a33e3.svg";